module.exports = __webpack_public_path__ + "static/media/Inner_fruit.c7d4fc71.svg";